import { StandardsSetsTitleInput } from "./StandardsSetsTitleInput.component";

export { StandardsSetsTitleInput };
